import React, { useCallback, useContext, useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { refundCapture } from '../../../util/sdkCallbacks';
import IntegrationPageSectionContext from '../StateManagement/IntegrationPageSectionContext';
import TestPanelContext from '../StateManagement/TestPanelContext';
import styles from './OrderActions.module.less';
import OrderActionButton from './OrderActionButton';
import LoadingOverlay from '../../../components/LoadingOverlay';
import { CaptionText } from '@paypalcorp/pp-react';
import DebouncedTextInput from '../../../components/DebouncedTextInput';
import { trackFieldChange, trackFieldFocus } from '../../../lib/fpti';

const OrderActions = ({ codeBlockKey, content }) => {
  const [loading, setLoading] = useState(false);
  const {
    lastCapture,
    code,
    SdkConfigurator: {
      sdkSettings: { clientId }
    },
    OrderConfigurator: { sellerId, updateBuyerEmailAddress }
  } = useContext(IntegrationPageSectionContext);

  const { updateLogs, toggleTestPanel } = useContext(TestPanelContext);
  const isSectionActive = code.status[codeBlockKey.split(',')[0]];
  const actionType = content?.action;
  const [buyerEmailAddress, setBuyerEmailAddress] = useState('');

  const csrfToken = useSelector((state) => state?.app?.csrfToken);
  const isUserLoggedIn = useSelector((state) => state?.app?.prunedUser?.isUserLoggedIn);
  const appIntegrationType = useSelector((state) => state?.app?.appIntegrationType);
  const captureIds = lastCapture.value;
  const handleRefund = useCallback(async () => {
    setLoading(true);
    await refundCapture({
      captureIds,
      csrfToken,
      updateLogs,
      toggleTestPanel,
      updateLastCapture: lastCapture.updateLastCapture,
      clientId: isUserLoggedIn ? clientId : null,
      appIntegrationType,
      sellerId
    });
    setLoading(false);
  }, [refundCapture, isUserLoggedIn, clientId, captureIds, csrfToken, updateLogs]);

  if (!isSectionActive) return <></>;

  return (
    <>
      {loading && <LoadingOverlay />}
      {actionType === 'email' ? (
        <>
          <div className={styles.email_item}>
            <CaptionText className={styles.email_label}>Buyer Email Address</CaptionText>
            <DebouncedTextInput
              className={styles.email_input}
              label="Email Address"
              value={buyerEmailAddress}
              type="text"
              onClick={() => trackFieldFocus('Buyer Email Address')}
              onChange={(value) => {
                trackFieldChange('Buyer Email Address', value);
                updateBuyerEmailAddress(value);
                setBuyerEmailAddress(value);
              }}
            />
          </div>
        </>
      ) : (
        <div className={styles.order_actions_container}>
          <OrderActionButton
            content={content?.refundCapture}
            id="refund"
            onClick={handleRefund}
            data={captureIds}
          />
        </div>
      )}
    </>
  );
};

OrderActions.propTypes = {
  content: PropTypes.object,
  codeBlockKey: PropTypes.string
};

OrderActions.defaultProps = {
  content: null,
  codeBlockKey: null
};

export default OrderActions;
